import { render, staticRenderFns } from "./Duplicado.vue?vue&type=template&id=7e81f223&"
import script from "./Duplicado.vue?vue&type=script&lang=js&"
export * from "./Duplicado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports